<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-0">
          <img src="/static/img/sokochan.png" alt style="max-height: 50px" />
        </h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <template v-if="check_privilege('sokochan')">
          <v-btn fab outline small color="primary" v-if="!isEdit" @click="editSetting">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn readonly fab outline small color="grey" v-on="on">
                <v-icon>lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</span>
          </v-tooltip>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('register_sokochan') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('connect_sokochan_service_for_more') }}</div>
          <v-btn
            depressed
            color="primary"
            :href="'https://sokochan.com/form/'"
            target="_blank"
            @click="step = 2"
            >{{ $t('register_sokochan') }}</v-btn
          >

          <v-btn flat @click="step = 2">
            {{ $t('already_have_an_account') }}
          </v-btn>
          <div>
            <a href="https://blog.zwiz.app/zwizxsokochan/" target="_blank">
              {{ $t('how_to_use_sokochan') }}</a
            >
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('connect_zwiz_with_sokochan') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div
            class="pa-2"
            style="position: relative; "
            :style="{ 'min-height': !check_privilege('sokochan') ? '300px' : '' }"
          >
            <v-premium-plan-popup2
              v-if="!check_privilege('sokochan')"
              type="premium"
            ></v-premium-plan-popup2>
            <div class="mb-2" v-if="showCancel">
              <div>
                {{ $t('enable_disable_sokochan') }}
              </div>
              <div>
                <toggle-button
                  class="mt-2"
                  :value="setting.status"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="toggleStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </div>
            </div>

            <template v-if="!showCancel">{{
              $t('after_receiving_confirmation_from_sokochan')
            }}</template>

            <template v-if="isEdit">
              <div class="caption">{{ $t('account_login') }}</div>
              <div class="form-control" :class="{ 'has-error': errors.has('account_login') }">
                <template>
                  <input
                    type="text"
                    v-model="setting.account_login"
                    v-validate="'required'"
                    name="setting.account_login"
                    data-vv-as="account_login"
                  />
                  <span class="text-error" v-if="errors.has('setting.account_login')">{{
                    errors.first('setting.account_login')
                  }}</span>
                </template>
              </div>

              <div class="caption">api_key</div>
              <div class="form-control" :class="{ 'has-error': errors.has('api_key') }">
                <template>
                  <input
                    type="text"
                    v-model="setting.api_key"
                    v-validate="'required'"
                    name="setting.api_key"
                    data-vv-as="api_key"
                  />
                  <span class="text-error" v-if="errors.has('setting.api_key')">{{
                    errors.first('setting.api_key')
                  }}</span>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="caption">token</div>
              <div v-if="!loading" class="primary--text">
                {{ setting.token ? setting.token : '-' }}
              </div>
            </template>

            <div class="mt-2 mb-2">
              <div>
                {{ $t('channel_setting') }}
              </div>
              <div>
                <template v-if="isEdit">
                  <v-select
                    v-model="current_url"
                    outline
                    single-line
                    :items="url_list"
                    v-validate="'required'"
                    :data-vv-as="$t('channel_setting')"
                    name="url"
                    :error="errors.has('url')"
                    :error-messages="errors.first('url')"
                  ></v-select>
                </template>
                <div class="primary--text" v-else>
                  <template v-if="current_url && current_url.text">
                    {{ current_url.text }}
                  </template>
                  <template v-else>-</template>
                </div>
              </div>
            </div>

            <div class="mb-2" v-if="showCancel">
              <div>
                {{ $t('เปิด/ปิด การใช้งาน Sokochan Sync Stock') }}
              </div>
              <div>
                <toggle-button
                  class="mt-2"
                  :value="setting.sync_stock_status"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="toggleSyncStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </div>
            </div>

            <div class="text-xs-center" v-if="isEdit">
              <v-btn color="grey" outline @click="onCancel" :loading="loading">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn color="primary" depressed @click="onSave" :loading="loading">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { cloneDeep } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      isEdit: false,

      loading: false,
      setting: {
        token: null,
        status: false,
        endpoint_url: null,
        sync_stock_status: false
      },
      showCancel: true,
      step: 1
    }
  },
  async mounted() {
    this.loading = true
    if (this.selectedBot.sokochan_info) {
      this.setting = {
        token: this.selectedBot.sokochan_info.token || null,
        status: this.selectedBot.sokochan_info.status || null,
        endpoint_url: this.selectedBot.sokochan_info.endpoint_url || null,
        sync_stock_status: this.selectedBot.sokochan_info.sync_stock_status || null
      }
      if (this.selectedBot.sokochan_info.token) {
        let token = atob(this.selectedBot.sokochan_info.token).split(':')
        this.setting.account_login = token[0]
        this.setting.api_key = token[1]
      }
    }
    this.setting.endpoint_url = 'https://oms.sokochan.com/api/1.0/'
    await this.$nextTick()
    if (this.setting.token == null) {
      this.editSetting()
      this.showCancel = false
    } else {
      this.step = 2
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    url_list() {
      let list = [
        {
          text: 'Production',
          value: 'https://oms.sokochan.com/api/1.0/'
        }
      ]

      if (this.selectedBot.pageid == '155062857877705') {
        list.push({
          text: 'Smooth E Production',
          value: 'https://shg.sokochan.com/api/1.0/'
        })
      }
      return list
    },
    current_url: {
      get() {
        let url = null

        try {
          url = this.url_list.find(el => {
            return this.setting.endpoint_url == el.value
          })
        } catch (error) {}
        return url || null
      },
      set(val) {
        if (val) {
          this.setting.endpoint_url = val
        } else {
          this.setting.endpoint_url = null
        }
      }
    }
  },
  methods: {
    async toggleSyncStatus() {
      const status = !this.setting.sync_stock_status
      try {
        await api.post_sokochan_save_token({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            sokochan_status: this.setting.status || false, // optional
            sokochan_token: btoa(`${this.setting.account_login}:${this.setting.api_key}`), // optional
            sokochan_endpoint_url: this.setting.endpoint_url, // optional
            sokochan_sync_stock_status: status // optional
          }
        })
        await this.$store.dispatch('updateBotDetail')
        this.setting.sync_stock_status = status
      } catch (error) {
        console.error(error)
      }
    },
    async toggleStatus() {
      const status = !this.setting.status
      try {
        await api.post_sokochan_save_token({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            sokochan_status: status, // optional
            sokochan_token: btoa(`${this.setting.account_login}:${this.setting.api_key}`), // optional
            sokochan_endpoint_url: this.setting.endpoint_url, // optional
            sokochan_sync_stock_status: this.setting.sync_stock_status || false // optional
          }
        })
        await this.$store.dispatch('updateBotDetail')
        this.setting.status = status
      } catch (error) {
        console.error(error)
      }
    },
    editSetting() {
      this.isEdit = true
      this.cached_setting = cloneDeep(this.setting)
    },
    onCancel() {
      this.isEdit = false
      this.setting = cloneDeep(this.cached_setting)
    },

    async onSave() {
      if (!this.check_privilege('sokochan')) return false
      this.loading = true
      try {
        var result = await this.$validator.validateAll()

        if (this.setting.token != null && this.setting.status == null) {
          this.setting.status = true
          this.setting.endpoint_url = ''
          this.setting.sync_stock_status = true
        }

        if (!result) {
          // do stuff if not valid.
          this.goToErrorInput()
          return false
        }

        await api.post_sokochan_save_token({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            sokochan_status: this.setting.status, // optional
            sokochan_token: btoa(`${this.setting.account_login}:${this.setting.api_key}`), // optional
            sokochan_endpoint_url: this.setting.endpoint_url, // optional
            sokochan_sync_stock_status: this.setting.sync_stock_status // optional
          }
        })
        this.setting.token = btoa(`${this.setting.account_login}:${this.setting.api_key}`)
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })
        this.cached_setting = cloneDeep(this.setting)

        this.isEdit = false
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SokochanManage.vue